import { View } from 'react-native'
import CloseButton from '~/components/CloseButton.tsx'
import Icon from '~/components/Icon.tsx'
import { SectionTitle } from '~/components/layout/Sections.tsx'
import { DisplayValue } from '~/components/typography/Content.tsx'
import { Button } from '~/components/ui/button.tsx'
import { Progress } from '~/components/ui/progress.tsx'
import { cn } from '~/lib/utils.ts'

export default function FlowHeader({
  className,
  title,
  totalPhases,
  currentPhase,
  phaseTitle,
  onClose,
  onReset,
}: {
  title?: string
  className?: string
  totalPhases?: number
  currentPhase?: number
  phaseTitle?: string
  onClose?: () => void
  onReset?: () => void
}) {
  const hasPhases = !!totalPhases && totalPhases > 1 && currentPhase !== undefined

  const progress = hasPhases ? ((currentPhase + 1) / totalPhases) * 100 : undefined

  return (
    <View className={cn('gap-2', className)}>
      <View className="relative flex-row items-center justify-between pb-2">
        {onClose && (
          <CloseButton
            className="-top-1 left-0 right-auto z-10"
            onPress={() => {
              onClose()
              return false
            }}
          />
        )}
        {title && <SectionTitle className="flex-1">{title}</SectionTitle>}

        {onReset && (
          <Button
            testID="flow-reset-button"
            variant="ghost"
            size="icon"
            className="absolute -top-1 right-0"
            onPress={onReset}>
            <Icon name="backspace-outline" size={22} />
          </Button>
        )}
      </View>
      {hasPhases ? (
        <View className="gap-4 pt-2">
          <Progress value={progress} />
          <View className="flex-row items-center justify-between">
            {phaseTitle && <DisplayValue>{phaseTitle}</DisplayValue>}
            <DisplayValue className="ml-auto text-right">
              {currentPhase + 1} / {totalPhases}
            </DisplayValue>
          </View>
        </View>
      ) : (
        <View className="-mx-6 h-[2px] bg-muted" />
      )}
    </View>
  )
}
